import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography, makeStyles, Theme } from '@material-ui/core'
import { BuildingFragment } from '../../generated/graphql'
import { formatArea } from '../../util/formatters'
import { Section } from '../common/Section'

export const useStyles = makeStyles((theme: Theme) => ({
  subtitle1: {
    color: theme.palette.grey[500],
    textTransform: 'none',
  },
  skipUppercase: {
    textTransform: 'none',
  },
}))

type Props = {
  building: BuildingFragment
}

export function BuildingTabCommonHeader({
  building,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Section>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="subtitle1" className={classes.subtitle1}>
            {t('building.tabs.common.buildingType')}
          </Typography>
          <Typography variant="h4">
            {t(`buildingType.${building.type}`)}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography variant="subtitle1" className={classes.subtitle1}>
            {t('unitName.area')}
          </Typography>
          <Typography variant="h4" className={classes.skipUppercase}>
            {formatArea(building.area)}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography variant="subtitle1" className={classes.subtitle1}>
            {t('building.tabs.common.multiplier')}
          </Typography>
          <Typography variant="h4" className={classes.skipUppercase}>
            x{building.multiplier}
          </Typography>
        </Grid>
      </Grid>
    </Section>
  )
}
